module.exports = __webpack_public_path__ + "assets/img/LJ-Hooker-eBook.25fc2e79.webp";